import { useEffect, useState } from "react";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import {
  Button,
  Group,
  LoadingOverlay,
  Modal,
  Select,
  Stack,
  Text,
  TextInput,
} from "@mantine/core";
import { IconEdit } from "@tabler/icons-react";
import { notifications } from "@mantine/notifications";
import BackButton from "../../../../../../components/View/BackButton";
import { editCron, findCron } from "../../../../../../api/ConfigsApi";
import Jobs from "../../jobs/Jobs";
import CreatableContactListSelector from "../../../../../../components/Selectors/CreatableContactListSelector";
import LinkedinAccountSelector from "../../../../../../components/Selectors/LinkedinAccountSelector";
import { DatePickerInput } from "@mantine/dates";
import dayjs from "dayjs";

const EditRefreshCron = ({ item, handleDone }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, setOpened] = useState(false);
  const [finding, setFinding] = useState(false);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState(null);
  const [itemProfile, setItemProfile] = useState(item);
  const [accountId, setAccountId] = useState(null);

  const handleOpen = () => {
    setOpened(true);
  };
  const handleClose = () => {
    setOpened(false);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setLoading(true);
    let formData = new FormData(e.target);
    let data = Object.fromEntries(formData);

    const args = {
      type: "refresh_linkedin_targeting_contact_list",
      contactlist_id: list.id,
      linkedin_account_id: accountId,
    };

    editCron({
      id: item.id,
      name: data?.name,
      frequency: data?.frequency,
      end_date: data?.end_date,
      args,
    })
      .then((response) => {
        notifications.show({
          message: lang.contact_lists.cron.edited,
          color: "tertiary.8",
        });
        handleClose();
        handleDone();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (opened) {
      setFinding(true);
      findCron(item.id)
        .then((response) => {
          let itemArgs = response.data.cron_profile.arguments;
          setItemProfile(response.data.cron_profile);
          setAccountId(itemArgs.linkedin_account_id);
          setList({
            id: itemArgs.contactlist_id,
          });
        })
        .finally(() => setFinding(false));
    }
  }, [opened, item.id]);

  return (
    <>
      <Button
        onClick={handleOpen}
        leftSection={<IconEdit size={18} />}
        variant="light"
        mr={"auto"}
      >
        {lang.contact_lists.cron.view}
      </Button>

      <Modal
        opened={opened}
        title={lang.contact_lists.cron.edit_title + item.name}
        onClose={handleClose}
        size={"50%"}
      >
        <LoadingOverlay visible={finding} />
        <Stack
          component={"form"}
          onSubmit={onSubmit}
          key={itemProfile?.arguments ? "a" : "b"}
        >
          <Group wrap="nowrap">
            <TextInput
              name="name"
              defaultValue={itemProfile.name}
              label={lang.prm.nurturing.create_name}
              placeholder={lang.prm.nurturing.create_name}
              required
              w={"100%"}
              autoFocus
              data-autofocus
              size="md"
            />

            <Select
              name="frequency"
              defaultValue={itemProfile.frequency}
              label={lang.sync_zapier.event_label}
              placeholder={lang.sync_zapier.event_label}
              required
              data={Object.keys(lang.sync_zapier.frequency).map((x) => ({
                value: x,
                label: lang.sync_zapier.frequency[x],
              }))}
              size="md"
            />

            <DatePickerInput
              label="Date d'arrêt"
              name="end_date"
              defaultValue={
                itemProfile?.end_date
                  ? dayjs(itemProfile?.end_date).toDate()
                  : null
              }
              // required
              size="md"
              w={300}
              popoverProps={{zIndex: 600}}
            />
          </Group>

          <CreatableContactListSelector
            value={list}
            setValue={setList}
            label={lang.contact_lists.cron.list_source}
            placeholder={lang.contact_lists.create.dialog.desc}
            w={"100%"}
            size="md"
            required
            disableCreate
            noDesc
          />

          <LinkedinAccountSelector
            label={lang.contact_lists.refresh_targeting.dialog.linkedin_account}
            required
            value={accountId}
            onChange={(v) => setAccountId(v?.id || null)}
            size={"md"}
          />

          {itemProfile?.state_details?.length > 0 && (
            <Group>
              <button
                style={{ display: "none" }}
                id="cron-reload"
                type="button"
                onClick={() => {
                  findCron(item.id).then((response) => {
                    setItemProfile(response.data.cron_profile);
                  });
                }}
              >
                Reload cron
              </button>
              <Text>{lang.contact_lists.cron.processes}</Text>
              <Jobs isCron={true} row={itemProfile} onDiff={() => {}} />
            </Group>
          )}

          <Group justify="end" mt={"lg"}>
            <BackButton onClick={handleClose} size="md" />
            <Button
              // disabled={
              //   type === "prm" ? !filter || filter?.values?.length === 0 : false
              // }
              leftSection={<IconEdit size={18} />}
              loading={loading}
              type="submit"
              size="md"
            >
              {lang.contact_lists.cron.edit}
            </Button>
          </Group>
        </Stack>
      </Modal>
    </>
  );
};

export default EditRefreshCron;
